import React from 'react'
import NewHeader from '../components/layout/NewHeader'
import Modal from "../components/layout/modal"

interface DrupalImage {
    url: string;
}

function App() {
    const [wrapperStyle, setWrapperStyle] = React.useState<React.CSSProperties & Record<string, string | number>>();
    const [background, setBackground] = React.useState<{ mobile: DrupalImage, desktop: DrupalImage } | null>(null)
    const [logo, setLogo] = React.useState<DrupalImage>(null);
    const [floatImages, setFloatImages] = React.useState<{ left: DrupalImage, right: DrupalImage } | null>();

    const [title, setTitle] = React.useState<string>('')
    const [description, setDescription] = React.useState<string>('')
    const [firstButton, setFirstButton] = React.useState<{ url: string, text: string }>({ url: '', text: '' })
    const [secondButton, setSecondButton] = React.useState<{ url: string, text: string }>({ url: '', text: '' })

    const sendDatalayer = (e: React.MouseEvent) => {
        e.preventDefault()

        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'CTA Thank you',
            'interaction': 'true',
            'component_name': 'MOTM_Thank you',
            'element_text': e.currentTarget.textContent,
            'campaign_description': 'Votaciones'
        });

        window.location.href = e.currentTarget.getAttribute('href') || ''

    }

    const gettpyc = async () => {
        const storedItems = JSON.parse(sessionStorage.getItem('TUP'));

        setBackground({ mobile: storedItems.typ2?.bgs?.bgm, desktop: storedItems.typ2?.bgs?.bg });
        setFloatImages({ left: storedItems.typ2?.bgs?.bgleft, right: storedItems.typ2?.bgs?.bgright });
        setLogo(storedItems.typ2?.bgs?.logo);
        setWrapperStyle({
            '--bg-color-title': storedItems.typ2?.bgs?.bgcolor1,
            '--bg-color': storedItems.typ2?.bgs?.bgcolor2,
            position: 'relative',
            zIndex: 9999
        })

        setTitle(storedItems.typ2?.title?.value || '');
        setDescription(storedItems.typ2?.desc?.value || '');
        setFirstButton(storedItems.typ2?.btn || { text: '', url: '' });
        setSecondButton(storedItems.typ2?.btn2 || { text: '', url: '' });
    }

    React.useEffect(() => {
        gettpyc();
    }, [])

    return (
        <div className="ar__wrapper_v2" style={wrapperStyle}>
            <NewHeader logo={logo?.url} />
            <Modal />
            <div className='americaPageThanks'>
                <div className="ar__america_thank ar__content__section">
                    {/* BACKGROUND IMAGE */}
                    {
                        (background?.mobile?.url || background?.desktop?.url)
                        && (
                            <picture>
                                <source media="(min-width: 991px)" srcSet={background.desktop.url} />
                                <img src={background.mobile.url || background.desktop.url} alt="" className="ar__login_v2__bg ar__login_v2_fade" />
                            </picture>
                        )
                    }

                    {/* FLOAT IMAGES */}
                    {floatImages?.left && <img className="ar__login_v2__left" src={floatImages?.left.url} alt="" title="" />}
                    {floatImages?.right && <img className="ar__login_v2__right" src={floatImages.right.url} alt="" title="" />}

                    <header className='ar__america_thank_header'>
                        <h1 className='ar__america_thank_title' dangerouslySetInnerHTML={{ __html: title }}></h1>
                    </header>

                    <div className='ar__america_thank_text' dangerouslySetInnerHTML={{ __html: description }}></div>

                    <div className='ar__america_thank_group'>
                        {firstButton.text && <a href={firstButton.url} className="ar__know-more blue-light ar__america_thank_button" onClick={sendDatalayer}>{firstButton.text}</a>}
                        {secondButton.text && <a href={secondButton.url} className="ar__know-more blue-light ar__america_thank_button" onClick={sendDatalayer}>{secondButton.text}</a>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default App
